import { Box, AHSeparator } from "arkh";

export function WorkspaceDetailNavigationHeader(props: {
  left: React.ReactNode;
  right: React.ReactNode;
}) {
  return (
    <Box color="surface-primary">
      <Box
        style={{
          maxWidth: 900,
          width: "100%",
          alignSelf: "center",
          flexDirection: "row",
          alignItems: "center",
          height: 50,
          justifyContent: "space-between",
        }}
        spaceHorizontal="medium"
      >
        {props.left}
        {props.right}
      </Box>
      <AHSeparator />
    </Box>
  );
}
export function WorkspaceDetailNavigationHeaderResponsive(props: {
  left: React.ReactNode;
  right: React.ReactNode;
}) {
  return (
    <Box color="surface-primary">
      <Box
        style={{
          width: "100%",
          alignSelf: "center",
          flexDirection: "row",
          alignItems: "center",
          height: 50,
          justifyContent: "space-between",
        }}
        spaceHorizontal="large"
      >
        {props.left}
        {props.right}
      </Box>
      <AHSeparator />
    </Box>
  );
}
